export default "__VITE_ASSET__Dg6asitY__"